import {useTheme} from '@mui/material';

import {QueryParamsEnum} from 'presentation/constants';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useMediaQueries, useQueryParams} from 'presentation/pages/private/hooks';
import {UseOdontoDuplicityDialogProps} from './types';
import {getOdontoStepPosition} from 'presentation/modules/booking/odonto/utils/getOdontoStepPosition';

export function useOdontoDuplicityDialog({scheduledBooking}: UseOdontoDuplicityDialogProps) {
	const {isManualLocation} = useBookingStore(state => state.bookingData);
	const setBookingData = useBookingStore(state => state.setBookingData);
	const setActiveBookingFlowStep = useBookingFlowStepsStore(state => state.setBookingStep);
	const {isMobile} = useMediaQueries();
	const {colors} = useTheme();
	const {setSearchParams} = useQueryParams();

	const handleSwapSpecialty = async () => {
		const {DISTRICT_STEP, UNIT_STEP} = getOdontoStepPosition({
			isManualLocation,
		});

		setActiveBookingFlowStep(isManualLocation ? DISTRICT_STEP : UNIT_STEP);

		setBookingData(prev => ({
			...prev,
			specialtyCode: scheduledBooking.specialtyCode,
			subSpecialtyCode:
				!scheduledBooking.subSpecialtyCode || scheduledBooking.subSpecialtyCode === '0'
					? ''
					: scheduledBooking.subSpecialtyCode,
			specialtyName: scheduledBooking.specialtyNameSelected ?? scheduledBooking.specialtyName,
			bookingType: scheduledBooking.bookingType,
			bookingNumber: scheduledBooking.bookingNumber,
			isRebooking: true,
			isScheduleScript: false,
			districtName: undefined,
			citiesNames: undefined,
			hasGeoDistrictsFilter: false,
		}));

		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.SEARCH_QUERY);
			return prev;
		});
	};

	return {
		handleSwapSpecialty,
		colors,
		isMobile,
	};
}
